'use client';

import { useEffect, useState } from 'react';
import { NotificationToast } from '../kit/NotificationToast';
import { useTranslation } from '@/kit/useTranslation';

export default function SessionExpiredToast() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const handleSessionExpired = (event) => {
      setMessage(event.detail.message);
      setOpen(true);
    };

    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  return (
    <NotificationToast
      open={open}
      title={t('session.sessionExpired')}
      message={message || t('session.sessionExpiredMessage')}
      severity="warning"
      onClose={() => setOpen(false)}
      actions={[
        {
          label: t('session.loginAgain'),
          onClick: () => {
            window.location.href = '/login';
          },
        },
      ]}
    />
  );
}
